/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ " and ": NonNullable<unknown>, " et ": NonNullable<unknown> }} Remove_Text_Curly_BracesInputs */

const en_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove text between ${i?.[" and "]}`)
};

const fr_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprimer le texte entre ${i?.[" et "]}`)
};

const de_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entferne den Text zwischen ${i?.[" and "]}`)
};

const it_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rimuovi il testo tra ${i?.[" and "]}`)
};

const ru_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Удалите текст между ${i?.[" and "]}`)
};

const es_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminar texto entre ${i?.[" and "]}`)
};

const zh_cn2_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除 ${i?.[" and "]} 之间的文本`)
};

const ja_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.[" and "]} 間のテキストを削除`)
};

const hi_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.[" and "]} के बीच का टेक्स्ट हटाएँ`)
};

const pt_pt2_remove_text_curly_braces = /** @type {(inputs: Remove_Text_Curly_BracesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover texto entre ${i?.[" and "]}`)
};

/**
* | output |
* | --- |
* | "Remove text between { and }" |
*
* @param {Remove_Text_Curly_BracesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_text_curly_braces = /** @type {((inputs: Remove_Text_Curly_BracesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Text_Curly_BracesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_text_curly_braces(inputs)
	if (locale === "de") return de_remove_text_curly_braces(inputs)
	if (locale === "it") return it_remove_text_curly_braces(inputs)
	if (locale === "ru") return ru_remove_text_curly_braces(inputs)
	if (locale === "es") return es_remove_text_curly_braces(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_text_curly_braces(inputs)
	if (locale === "ja") return ja_remove_text_curly_braces(inputs)
	if (locale === "hi") return hi_remove_text_curly_braces(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_text_curly_braces(inputs)
	return en_remove_text_curly_braces(inputs)
});